import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SplashScreen from './components/SplashScreen';
import Home from './pages/Home';
import OrderStatus from './pages/OrderStatus';
import Checkout from './pages/Checkout';
import Terms from './pages/Terms';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import OrderLookup from './pages/OrderLookup';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ResellerPanel from './pages/ResellerPanel';
import StatusPage from './pages/StatusPage';
import Reviews from './pages/Reviews';
import ToolDocs from './pages/ToolDocs';
import NotFound from './pages/NotFound';
import './styles/App.css';

// Funnel tracking helper
const trackFunnel = (event, meta) => {
  try { fetch('/api/funnel/track', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ event, meta }) }); } catch {}
};
window.trackFunnel = trackFunnel;

function App() {
  const [user, setUser] = useState(null);
  const [splashDone, setSplashDone] = useState(() => !!sessionStorage.getItem('splashShown'));

  useEffect(() => {
    const stored = localStorage.getItem('user');
    if (stored) {
      try { setUser(JSON.parse(stored)); } catch { localStorage.removeItem('user'); }
    }
    // Track page visit
    trackFunnel('page_visit', { path: window.location.pathname });
  }, []);

  const handleLogin = (u) => setUser(u);
  const handleLogout = () => { setUser(null); localStorage.removeItem('token'); localStorage.removeItem('user'); };

  return (
    <>
      {!splashDone && (
        <SplashScreen onFinished={() => { setSplashDone(true); sessionStorage.setItem('splashShown', '1'); }} />
      )}
      <Router>
        <Routes>
          {/* Dashboard routes — no navbar/footer */}
          <Route path="/dashboard" element={
            user ? <Dashboard user={user} onLogout={handleLogout} /> : <Navigate to="/login" />
          } />
          <Route path="/login" element={
            user ? <Navigate to="/dashboard" /> : (
              <div className="app-container"><Login onLogin={handleLogin} /></div>
            )
          } />
          <Route path="/register" element={
            user ? <Navigate to="/dashboard" /> : (
              <div className="app-container"><Register onLogin={handleLogin} /></div>
            )
          } />
          <Route path="/forgot-password" element={
            <div className="app-container"><ForgotPassword /></div>
          } />
          <Route path="/reset-password" element={
            <div className="app-container"><ResetPassword /></div>
          } />
          <Route path="/reseller" element={<ResellerPanel />} />
          <Route path="/docs" element={<ToolDocs />} />

          {/* Public routes */}
          <Route path="*" element={
            <div className="app-container">
              <Navbar user={user} onLogout={handleLogout} />
              <div className="main-content">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/order-status" element={<OrderStatus />} />
                  <Route path="/order/:orderId" element={<OrderStatus />} />
                  <Route path="/track" element={<OrderLookup />} />
                  <Route path="/checkout/:orderId" element={<Checkout />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/status" element={<StatusPage />} />
                  <Route path="/reviews" element={<Reviews />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </div>
              <Footer />
            </div>
          } />
        </Routes>
      </Router>
    </>
  );
}

export default App;
